import React from 'react'

const Banner: React.FC<{ block: any }> = ({ block }) => {
  return (
    <section className={`block ${block._template}  ${block.css_class_name}`}>
      <div className="container">
        <div className="banner-row row">
          {block.items.map(item => <BannerItem key={item.title} item={item} />)}
        </div>
      </div>
    </section>
  )
}

export const BannerItem: React.FC<{ item }> = ({ item }) => {
  return (
    <div className="banner-item">
      <div className="banner-item__title" dangerouslySetInnerHTML={{ __html: item.title}}></div>
      <div className="banner-item__subtitle" dangerouslySetInnerHTML={{ __html: item.subtitle}}></div>
      <div className="banner-item__text" dangerouslySetInnerHTML={{ __html: item.text}}></div>
    </div>
  )
}

export default Banner;